<template>
  <div class="my-5">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="8" offset-md="2">
          <v-card rounded>
            <v-card-title>
              Receipt
              <v-spacer />
              <!-- <v-btn @click="download" outlined dark color="orange darken-3">
                <v-icon left>mdi-cloud-download</v-icon>
                Download
              </v-btn> -->
            </v-card-title>
            <v-divider />

            <v-card-text
              class="pa-0"
              style="position: relative; background: #525659"
              :style="{
                height: isMobile ? 'auto' : '80vh',
                minHeight: isMobile ? '300px' : '700px',
                background: isMobile ? '#ffffff' : '#525659',
              }"
            >
              <!-- Loader while Blob URL is being created/loaded -->
              <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
                <v-skeleton-loader type="image" height="100%" />
              </div>

              <template v-else>
                <!-- Mobile Optimized View -->
                <div
                  v-if="isMobile"
                  class="pa-12 text-center d-flex flex-column align-center justify-center"
                >
                  <v-icon size="100" color="primary lighten-4"
                    >mdi-file-pdf-box</v-icon
                  >
                  <div
                    class="mt-6 grey--text text--darken-2 headline font-weight-bold"
                  >
                    Receipt Preview
                  </div>
                  <div class="mt-2 grey--text subtitle-1 mb-8">
                    Your receipt is ready. Since you are on a mobile device,
                    please use the button below to view it.
                  </div>
                  <v-btn
                    x-large
                    color="primary"
                    class="text-none px-8 rounded-lg shadow-lg"
                    @click="openPdfInNewTab"
                  >
                    <v-icon left>mdi-eye</v-icon>
                    Open Receipt
                  </v-btn>
                  <div class="mt-4 grey--text caption">
                    The document will open in your device's native PDF viewer.
                  </div>
                </div>

                <!-- Desktop Iframe View -->
                <iframe
                  v-else
                  :src="pdfUrl"
                  width="100%"
                  height="100%"
                  frameborder="0"
                  style="border: none; display: block"
                  title="Receipt Viewer"
                  loading="lazy"
                ></iframe>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import fileType from "file-type";
export default {
  name: "Receipt",
  data() {
    return {
      pdfUrl: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Events/getReceipt", v.$route.params.receiptNo);
    });
  },
  watch: {
    receipt: {
      immediate: true,
      handler(val) {
        if (val) {
          this.createPdfUrl(val);
        }
      },
    },
  },
  computed: {
    receipt() {
      return this.$store.getters["Events/receipt"];
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  methods: {
    createPdfUrl(base64) {
      // Clear existing URL if any
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }

      try {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (e) {
        console.error("Error creating PDF Blob URL:", e);
        this.pdfUrl = null;
      }
    },
    /**
     * Opens PDF in a new tab - most reliable for mobile devices
     */
    openPdfInNewTab() {
      if (!this.pdfUrl) return;
      window.open(this.pdfUrl, "_blank");
    },
    download: async function () {
      const myBuffer = Buffer.from(this.receipt, "base64");
      await fileType.fromBuffer(myBuffer).then((res) => {
        const path = `data:${res.mime})};base64,${this.receipt}`;
        const element = document.createElement("a");
        element.setAttribute("href", path);
        element.setAttribute(
          "download",
          `${this.$root.decryptRoute(this.$route).params.receiptNo}.pdf`
        );
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      });
    },
  },
  beforeDestroy() {
    if (this.pdfUrl) {
      URL.revokeObjectURL(this.pdfUrl);
    }
  },
};
</script>

<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
